{
  "Number": "Não",
  "Starttime": "Hora de início",
  "From": "A partir de",
  "To": "Para",
  "Duration": "Duração",
  "NAME": "CallRecording"
}